import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AdminCase } from "../models";
import { WriteResource } from "../types";
import { RootState } from "../store";
import { putCaseOnHoldApi } from "../api";

export interface PutOnHoldCaseForm {
  readonly case: AdminCase;
  readonly reasonForChange: string | null;
}

export type PutOnHoldCaseDialogState =
  | {
      readonly isOpen: true;
      readonly case: WriteResource<PutOnHoldCaseForm, AdminCase>;
    }
  | {
      readonly isOpen: false;
    };

// thunks
export const casePutOnHold = createAsyncThunk(
  "putOnHoldCaseDialog/casePutOnHold",
  async (_: void, thunkApi) => {
    const { getState } = thunkApi;
    const rootState = getState() as RootState;
    const state = rootState.putOnHoldCaseDialog;

    if (state.isOpen) {
      await putCaseOnHoldApi(state.case.data.case.id, state.case.data.reasonForChange || "");
    }
  }
);

export const putOnHoldCaseDialogSlice = createSlice({
  name: "putOnHoldCaseDialog",
  initialState: { isOpen: false } as PutOnHoldCaseDialogState,
  reducers: {
    openPutOnHoldCaseDialog: (state, action) => {
      return {
        isOpen: true,
        case: {
          data: {
            case: action.payload,
            reasonForChange: null
          }
        }
      };
    },
    closePutOnHoldCaseDialog: state => {
      state.isOpen = false;
    },
    setPutOnHoldCaseForm: (state, action) => {
      if (state.isOpen) {
        state.case = {
          data: action.payload
        };
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(casePutOnHold.fulfilled, () => {
      return { isOpen: false } as PutOnHoldCaseDialogState;
    });
    builder.addCase(casePutOnHold.rejected, (state, action) => {
      if (state.isOpen) {
        state.case = {
          data: state.case.data,
          errorMessage: action.error.message
        };
      }
    });
  }
});

export const {
  openPutOnHoldCaseDialog,
  closePutOnHoldCaseDialog,
  setPutOnHoldCaseForm
} = putOnHoldCaseDialogSlice.actions;
export default putOnHoldCaseDialogSlice.reducer;
